var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ContentVideoPlayer',{attrs:{"is-presentation":true,"session-id":_vm.sessionId,"presentation-id":_vm.presentationId}})
}
var staticRenderFns = []

export { render, staticRenderFns }